import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import PostEditor from "./PostEditor";
import UserAvatar from "./UserAvatar";

const styleSheet = theme => ({
    flex: {
        display: "flex"
    },
    avatarContainer: {
        height: "inherit"
    },
    container: {
        marginTop: theme.spacing.unit * 2,
        flex: 1
    }
});

class CommentEditor extends Component {
    componentDidMount() {
        if (this.editor) {
            this.editor.focus();
        }
    }

    render() {
        const {
            placeholder,
            classes,
            avatarURL,
            displayName,
            onChange,
            text
        } = this.props;
        return (
            <div className={classes.flex}>
                <div className={classes.avatarContainer}>
                    <UserAvatar
                        avatarURL={avatarURL}
                        displayName={displayName}
                    />
                </div>
                <div className={classes.container}>
                    <PostEditor
                        innerRef={r => {
                            this.editor = r;
                        }}
                        onChange={onChange}
                        text={text}
                        placeholder={placeholder}
                    />
                </div>
            </div>
        );
    }
}

CommentEditor.propTypes = {
    placeholder: PropTypes.string,
    avatarURL: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    rootRef: PropTypes.func,
    text: PropTypes.string,
    classes: PropTypes.object
};

CommentEditor.defaultProps = {
    placeholder: "",
    text: "",
    onChange: () => {},
    rootRef: () => {}
};

export default withStyles(styleSheet)(CommentEditor);



// WEBPACK FOOTER //
// ./src/components/CommentEditor.jsx